import React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { v4 } from 'uuid';
import { getLocalStorageItem, popup } from '../../../utils';
import { addMessage, deleteMessage } from '../../../redux';
import { sendMessageAPI } from '../../../utils/apiServices/chatsAPI';
import { connectSocket } from '../../../constants/socketClient';
import { Input } from 'react-chat-elements';
import { LOCAL_STORAGE } from '../../../constants';

export const CustomerChatFooter = () => {
    const dispatch = useDispatch();
    const chatList = useSelector((s) => s.chat?.chatList?.[0]);
    const currentUser = useSelector((s) => s.chat?.selectedUser);
    const role = useSelector((s) => s.user.role);
    const senderName = useSelector((s) => s.user.fullName);
    const userId = getLocalStorageItem(LOCAL_STORAGE.USER_ID);

    const sendMessage = async (text) => {
        let id = v4();
        const trimmedText = text?.trim();
        if (!trimmedText) return;
        if (!chatList?.chat_id || !chatList?.user_id) {
            popup('error', 'No active chat selected');
            return;
        }
        const msg = {
            id,
            position: 'right',
            type: 'text',
            text,
            date: new Date(),
            title: senderName,
        };
        // const socket = getSocket();
        const socket = connectSocket(userId);
        socket.emit('send-message', {
            id,
            chat_id: chatList?.chat_id,
            sender: chatList?.user_id,
            sender_name: senderName,
            sender_role: role,
            receiver_role: currentUser.role_code,
            receiver: chatList?.management_id,
            message: trimmedText,
            receiver_name: currentUser.full_name,
            receiver_email: currentUser.email,
        });
        dispatch(addMessage(msg));
        try {
            await sendMessageAPI({
                id: id,
                chat_id: chatList?.chat_id,
                sender_id: chatList?.user_id,
                message: trimmedText,
            });
        } catch (error) {
            setTimeout(() => dispatch(deleteMessage(id)), 1000);
            popup('error', 'Error sending message');
        }
    };

    return (
        <div className='chat-footer'>
            <Input
                placeholder='Type a message...'
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        sendMessage(e.target.value);
                        e.target.value = '';
                    }
                }}
                multiline={false}
                autofocus
            />
        </div>
    );
};
